export enum TagKind {
    DEFAULT = "default",
    KEY = "key",
    WARNING = "warning",
    ERROR = "error",
    PENDING = "pending",
    SUCCESS = "success",
    INFO = "info",
}
